import { render, staticRenderFns } from "./resourcesdialogtwo.vue?vue&type=template&id=90b0a136&scoped=true"
import script from "./resourcesdialogtwo.vue?vue&type=script&lang=js"
export * from "./resourcesdialogtwo.vue?vue&type=script&lang=js"
import style0 from "./resourcesdialogtwo.vue?vue&type=style&index=0&id=90b0a136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b0a136",
  null
  
)

export default component.exports